export default {"list":"zKPKw","--mode-dark":"GDfx-","--columns":"meyPe"};